<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline red lighten-2"
          primary-title
        >
          Delete
        </v-card-title>

        <v-card-text>
          This action will remove the entity from database and all the data in it.<br/>
          Do you really want to delete a <b>{{item.name || item.alias}}</b>?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            NO
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="confirm"
          >
            YES
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    item: Object || null,
  },
  data () {
    return {
      dialog: false,
    }
  },
  mounted() {
    this.dialog = true;
  },
  methods: {
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.$emit('close');
      });
    },
    confirm() {
      this.$emit('confirm', this.item);
      this.$nextTick(() => {
        this.$emit('close');
      })
    }
  },
  watch: {
    dialog (val) {
      val || this.close();
    },
  },
}
</script>